import React from 'react'


const SearchIcon = ({height}) => (
	<svg  className="search-box__search-icon" height={height? height : null} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
		 viewBox="0 0 17.8 17.8"  >
		<g>
			<path  d="M12.7,11.2h-0.8l-0.3-0.3c1-1.2,1.6-2.6,1.6-4.3c0-3.6-3-6.6-6.6-6.6S0,3,0,6.6c0,3.6,3,6.6,6.6,6.6
				c1.6,0,3.1-0.6,4.3-1.6l0.3,0.3v0.8l5.1,5.1l1.5-1.5L12.7,11.2z M6.6,11.2c-2.5,0-4.6-2-4.6-4.6C2,4.1,4.1,2,6.6,2s4.6,2,4.6,4.6
				C11.2,9.1,9.1,11.2,6.6,11.2z"/>
		</g>
	</svg>
)

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/images/icons/SearchIcon.jsx